import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { TriggerSummary } from '@/models/sensors-dto'
import SensorFormattedDetails from './SensorFormattedDetails.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TriggerDetailsPanel',
  props: {
    trigger: null
  },
  setup(__props: any) {

const props = __props as {
  trigger: TriggerSummary
}



const details = computed(() => {
  const {lookahead, threshold, currentVolume, flowRate} = props.trigger;

  return [
    {
      label: 'Threshold Value',
      value: threshold ?? '~',
      units: 'bbls',
    },
    {
      label: 'Lookahead Period',
      value: lookahead ?? '~',
      units: 'days',
    },
    {
      label: 'Flow Rate',
      value: flowRate ?? '~',
      units: 'bbls/hr',
    },
    {
      label: 'Current Volume',
      value: currentVolume ?? '~',
      units: 'bbls',
    },
  ]
})

return { __sfc: true,props, details, SensorFormattedDetails }
}

})